<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Foreword</p>
<p class="noindent">I bleed wine and gold, and Cleveland is my home! The city is flourishing now and ready to accept a winner. I’m glad a book is being written so more people can hear about the team’s rich history. We have come so close many times, and I believe that one day we can get over the hump!</p>
<p class="right1"><i>—Austin Carr</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// for3.vue?622b56b8